export default function ProjectsTable({ sectionId, projects, onDelete }) {
  return (
    <section id={sectionId} className="rounded-[32px] border border-white/10 bg-[#111112]/90 p-6 shadow-xl shadow-black/20">
      <div className="mb-5 flex items-center justify-between gap-4">
        <div>
          <p className="text-sm uppercase tracking-[0.35em] text-zinc-500">Projects</p>
          <h2 className="mt-2 text-2xl font-black text-white">إدارة المشاريع</h2>
        </div>
        <button className="rounded-2xl bg-[#22c55e] px-4 py-2 text-xs font-black uppercase tracking-[0.25em] text-black transition hover:bg-emerald-200">
          إضافة مشروع
        </button>
      </div>

      <div className="overflow-hidden rounded-[28px] border border-white/10">
        <table className="min-w-full border-collapse text-left text-sm">
          <thead className="bg-[#08080b] text-xs uppercase tracking-[0.35em] text-zinc-500">
            <tr>
              <th className="px-4 py-4">المشروع</th>
              <th className="px-4 py-4">العميل</th>
              <th className="px-4 py-4">الحالة</th>
              <th className="px-4 py-4">تحكم</th>
            </tr>
          </thead>
          <tbody>
            {projects.length ? projects.map((item) => (
              <tr key={item.id} className="border-t border-white/5 bg-[#0f1013] hover:bg-[#16171b]">
                <td className="px-4 py-4 text-zinc-100">{item.title || "-"}</td>
                <td className="px-4 py-4 text-zinc-400">{item.client || "غير معروف"}</td>
                <td className="px-4 py-4 text-zinc-300">{item.status || "Active"}</td>
                <td className="px-4 py-4">
                  <div className="flex flex-wrap gap-2">
                    <button className="rounded-2xl border border-white/10 bg-white/5 px-3 py-1 text-xs font-black uppercase tracking-[0.25em] text-zinc-300 hover:bg-white/10">تعديل</button>
                    <button onClick={() => onDelete(item.id)} className="rounded-2xl border border-rose-400/20 bg-rose-500/10 px-3 py-1 text-xs font-black uppercase tracking-[0.25em] text-rose-300 hover:bg-rose-500/20">حذف</button>
                  </div>
                </td>
              </tr>
            )) : (
              <tr>
                <td colSpan="4" className="px-4 py-6 text-center text-sm text-zinc-400">لا توجد مشاريع حتى الآن.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </section>
  );
}
